import styled from 'styled-components/native';
import Feather from 'react-native-vector-icons/Feather';
import FontAwesome from 'react-native-vector-icons/FontAwesome';

import {RFValue} from 'react-native-responsive-fontsize';

import FastImage from '../../components/Interface/Images/FastImageWithFallback';
import { isIphoneX} from 'react-native-iphone-screen-helper';

export const Container = styled.View`
  flex: 1;
  background: ${({theme}) => theme.colors.background};
`;

export const Content = styled.View`
  padding: 0 24px;
  flex: 1;
`;

export const UserWrapper = styled.TouchableOpacity.attrs(() => ({
  activeOpacity: 1,
}))`
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const ProfileButton = styled.TouchableOpacity`
  height: ${RFValue(32)}px;
  width: ${RFValue(32)}px;
  border-radius: ${RFValue(16)}px;
  background-color: ${({theme}) => theme.colors.profile_background_reverse};
  justify-content: center;
  align-items: center;
`;

export const ChipIconSolid = styled(Feather)`
  color: ${({theme}) => theme.colors.profile_initials_reverse};
  font-size: ${RFValue(16)}px;
`;

export const ProfileInitials = styled.Text`
  color: ${({theme}) => theme.colors.profile_initials_reverse};
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(12)}px;
`;

export const UserInfoWrapper = styled.View`
  align-items: center;
  flex-direction: row;
  border-style: solid;
  border-color: ${({theme}) => theme.colors.border};
  border-bottom-width: 1px;
  flex:1;
  margin: 0 -24px;
  padding: 0 24px;
  padding-bottom: ${RFValue(12)}px;
`;

export const UserInfo = styled.View`
  flex-direction: column;
  margin-left: ${RFValue(12)}px;
  justify-content: flex-start;
  flex: 1;
`;

//@ts-ignore
export const Photo = styled(FastImage)`
  width: ${RFValue(45)}px;
  height: ${RFValue(45)}px;
  border-radius: ${RFValue(50)}px;
`;

export const UserGreeting = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(11)}px;
  font-family: ${({theme}) => theme.fonts.regular};
`;
export const UserName = styled.Text`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(12)}px;
  width: 100%;
  text-transform: capitalize;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const Menu = styled.ScrollView`
  padding-top: ${RFValue(20)}px;
`;

export const MenuGroup = styled.View`
  margin-bottom: ${RFValue(12)}px;
`;

export const GroupTitle = styled.Text`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(12)}px;
  margin-bottom: ${RFValue(4)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const GroupTitleRow = styled.View`
  flex-direction: row;
  align-items: center;
  margin-bottom: ${RFValue(4)}px;
`;

export const GroupTitleIcon = styled(FontAwesome)`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(14)}px;
  margin-right: ${RFValue(6)}px;
`;

export const Item = styled.View`

`;

export const LeftContent = styled.View`
  flex-direction: row;
  align-items: center;
`;
export const ArrowIcon = styled(Feather)`
  font-size: ${RFValue(16)}px;
  color: ${({theme}) => theme.colors.black};
`;

export const Button = styled.TouchableOpacity.attrs(() => ({
  activeOpacity: 1,
}))`
  flex-direction: row;
  height: ${RFValue(42)}px;
  justify-content: space-between;
  align-items: center;

`;

export const ItemTitle = styled.Text`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(12)}px;
  margin-left: ${RFValue(16)}px;
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const VersionButton = styled.TouchableOpacity`
  margin-bottom: ${RFValue(12)}px;
`;

export const Version = styled.Text`
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(10)}px;
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const Footer = styled.View`
  padding-bottom: ${!isIphoneX() ? RFValue(20) : 0}px;
`;
